import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-not-found',
  templateUrl: './payment-not-found.component.html',
  styleUrls: ['./payment-not-found.component.css']
})
export class PaymentNotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/components/payment/payment-not-found/payment-not-found.component.ts